module.exports = __webpack_public_path__ + "static/media/sad_face_no_shadow.26e7c54a.svg";